import React, { useState } from 'react';
import { Checkbox } from 'zarm';

import componentConfig from './componentConfig';
import { ICheckboxItemProps, ICheckboxItem } from './type';
import { deepCopy } from '../../utils/tools';

const getName = (item: ICheckboxItem) => {
  return item.dataBind || item.name;
};

const CheckboxItem = (props: ICheckboxItemProps) => {
  const {
    label,
    childrens,
    name,
    value: fvalue,
    checked: fchecked,
    disabled,
    onChange,
  } = props;

  const [checked, setChecked] = useState(fchecked || false);
  const [value, setValue] = useState(fvalue || {});

  // 子组件change事件
  const onChildChange = (item: ICheckboxItem) => {
    const { value: subValue, name: subName, dataBind } = item;
    const tempname = subName || dataBind;
    let isExiteIndex = -1;
    const copyValue = deepCopy(value);

    if (copyValue.children && Array.isArray(copyValue.children) && copyValue.children.length) {
      copyValue.children.forEach((child: ICheckboxItem, index: number) => {
        if (child.name === getName(item)) {
          isExiteIndex = index;
        }
      });

      if (isExiteIndex === -1) {
        copyValue.children.push({ name: getName(item), value: item.value });
      } else {
        copyValue.children.splice(isExiteIndex, 1, { name: tempname, value: subValue });
      }
    } else {
      copyValue.children = [{ name: tempname, value: subValue }];
    }

    copyValue.name = name;
    copyValue.checked = Boolean(checked);

    setValue(copyValue);

    onChange && onChange(copyValue);
  };

  const bindData = (item) => {
    const { value: bVal, defaultValue: bDefauleValue } = props;
    if (bVal && Array.isArray(bVal) && bVal.length) {
      bVal.forEach((bItem) => {
        if (bItem.name === (item.name || item.dataBind)) {
          item.defaultValue = bItem.value;
        }
      });
    } else if (bDefauleValue && Array.isArray(bDefauleValue) && bDefauleValue.length) {
      bDefauleValue.forEach((bItem) => {
        if (bItem.name === (item.name || item.dataBind)) {
          item.defaultValue = bItem.value;
        }
      });
    }
    return item;
  };

  // 第一级复选框change
  const onCheckboxChange = () => {
    const temp = { checked: !checked, name };

    setChecked(!checked);
    setValue(temp);

    onChange && onChange(temp);
  };

  const renderChild = () => {
    if (!(childrens && Array.isArray(childrens) && childrens.length)) {
      return;
    }

    return childrens.map((item, index) => {
      const { widget } = item;
      const Components = componentConfig[widget] ? componentConfig[widget] : null;

      if (item.wprops) {
        item = Object.assign(item, item.wprops);
        delete item.wprops;
      }
      const lItem = bindData(item);

      return <Components onChange={onChildChange} key={index} {...lItem} />;
    });
  };

  return (
    <div>
      <Checkbox
        checked={checked}
        onChange={onCheckboxChange}
        disabled={disabled}
      >
        {label}
      </Checkbox>
      {
        checked && renderChild()
      }
    </div>
  );
};

export default CheckboxItem;
